<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><img alt="images" src="images/com-a.jpg"/> <em class="italic">List of Maps</em></h2>
<h2 class="toc1">Maps by Edward Alexander</h2>
<h2 class="toc"><a href="#/xhtml/10_Chapter01#fig1">Offshore Blockade &amp; Coasts and Harbors Naval Theaters</a></h2>
<h2 class="toc"><a id="page_xiii"></a><a href="#/xhtml/13_Chapter04#fig2">Voyage of <em class="italic">Clotilda</em>, The Last Slaver</a></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter10#fig3" title="Link target outside of Sample">California Gold Route</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter12#fig4" title="Link target outside of Sample">Battle of Port Royal</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Chapter14#fig5" title="Link target outside of Sample">Heartland Rivers Naval Theater</span></h2>
<h2 class="toc"><span href="#/xhtml/27_Chapter18#fig6" title="Link target outside of Sample">Burnside Expedition</span></h2>
<h2 class="toc"><span href="#/xhtml/29_Chapter20#fig7" title="Link target outside of Sample">Hampton Roads Tour Guide</span></h2>
<h2 class="toc"><span href="#/xhtml/32_Chapter23#fig8" title="Link target outside of Sample">Battle of Shiloh</span></h2>
<h2 class="toc"><span href="#/xhtml/33_Chapter24#fig9" title="Link target outside of Sample">Battle of Forts Jackson and Saint Philip</span></h2>
<h2 class="toc"><span href="#/xhtml/42_Chapter33#fig10" title="Link target outside of Sample">Jenkins’s Cavalry Raid on Steamboat <em class="italic">Victor No.</em></span></h2>
<h2 class="toc"><span href="#/xhtml/43_Chapter34#fig11" title="Link target outside of Sample">Battle of Portland Harbor</span></h2>
<h2 class="toc"><span href="#/xhtml/47_Chapter38#fig12" title="Link target outside of Sample">Battle of Plymouth</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Maps.vue?eb8040aa